<template>
  <div class="mt-2">
    <div class="row">
      <div class="col-md-3">
        <form-checkbox :disabled="true" :model="client" attribute="recordInbound" :chk-label="$t('recordInbound')"></form-checkbox>
      </div>
      <div class="col-md-3">
        <form-checkbox :disabled="true" :model="client" attribute="recordOutbound" :chk-label="$t('recordOutbound')"></form-checkbox>
      </div>
      <div class="col-md-3">
        <form-checkbox :disabled="true" :model="client" attribute="recordLocal" :chk-label="$t('recordLocal')"></form-checkbox>
      </div>
      <div class="col-md-3">
        <form-checkbox :disabled="true" :model="client" attribute="callConnectPromptSounds" :chk-label="$t('callConnectPromptSounds')"></form-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <form-checkbox :disabled="true" :model="client" attribute="transcriptDisabled" :chk-label="$t('transcriptDisabled')"></form-checkbox>
      </div>
      <div class="col-md">
        <form-checkbox :disabled="true" :model="client"
                       attribute="customCallStatusEnabled" :chk-label="$t('customCallStatusEnabled')"></form-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <form-checkbox :disabled="true" :model="client" attribute="phoneIdleEnabled" :chk-label="$t('phoneIdleEnabled')"></form-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['client'],
  data() {
    return {
      saveLoading: false,
      loading: true
    }
  },
  i18n: {
    messages: {
      vi: {
        recordInbound: "Ghi âm cuộc gọi đến",
        recordOutbound: "Ghi âm cuộc gọi đi",
        recordLocal: "Ghi âm cuộc gọi nội bộ",
        callConnectPromptSounds: "Âm báo khi bắt đầu hoặc kết thúc cuộc gọi",
        transcriptDisabled: "Không sử dụng tính năng ghi nhận nội dung cuộc gọi thành văn bản",
        customCallStatusEnabled: "Báo cáo khi kết thúc cuộc gọi",
        phoneIdleEnabled: "Cho phép nhân viên tắt nhận cuộc gọi",
      },
      en: {
        recordInbound: "Ghi âm cuộc gọi đến",
        recordOutbound: "Ghi âm cuộc gọi đi",
        recordLocal: "Ghi âm cuộc gọi nội bộ",
        callConnectPromptSounds: "Âm báo khi bắt đầu hoặc kết thúc cuộc gọi",
        transcriptDisabled: "Không sử dụng tính năng ghi nhận nội dung cuộc gọi thành văn bản",
        customCallStatusEnabled: "Báo cáo khi kết thúc cuộc gọi",
        phoneIdleEnabled: "Cho phép nhân viên tắt nhận cuộc gọi",
      }
    }
  }
}
</script>